const BASE_URL = process.env.REACT_APP_API_ENDPOINT;
export const STRIPE_ENDPOINT = `${BASE_URL}/stripe`;
export const AUTHENTICATION_ENDPOINT = `${BASE_URL}/auth`;
export const CUSTOMERS_ENDPOINT = `${BASE_URL}/customers`;
export const PURCHASEEMAILS_ENDPOINT = `${BASE_URL}/email/purchaseemails`;